import Typography from '@mui/material/Typography';
import { useTasksByFilterDocument } from 'features/tasks';
import React from 'react';
import { FilterDocuments } from 'shared/constants';

import * as Styled from './inbox-count.style';

export const LoadingInboxCount: React.FC = () => <Styled.Container $loading />;

export const InboxCount: React.FC = () => {
  const tasks = useTasksByFilterDocument(
    FilterDocuments.Inbox.defaultFilterDocument,
  );

  return !!tasks.length ? (
    <Styled.Container>
      <Typography variant="overline" component="span">
        {tasks.length}
      </Typography>
    </Styled.Container>
  ) : null;
};
